import { useQuery } from "@tanstack/react-query"

import { DepositConfiguration } from "modules/Booking/common/interfaces"
import { waitForFieldUpdate } from "modules/BookingCommon/common/waitForFieldUpdate"
import { DEPOSIT_STATUSES } from "modules/Booking/common/constants/depositStatuses"
import { PaymentSystemType } from "utils/interfaces"
import { getOrderPaymentStatus, PaymentStatusData } from "modules/BookingCommon/common/utils"
import { PaymentStatus } from "components/ClientCardAttachment/constants"
import { httpClient } from "utils/infrastructure/httpClient"

const DEPOSIT_CONFIGURATION_KEY = "DEPOSIT_CONFIGURATION_KEY"

export interface DepositInfoResponse {
    bookings: string[]
    configuration: DepositConfiguration
    order_id: number
    order_hash: string
    hash: string
    payment_system: PaymentSystemType
    price: string
    price_usd: string | number
    price_raw: string
    price_raw_usd: string
    psy: {
        hash_id: string
        display_name: string
    }
    status: DEPOSIT_STATUSES
}

function getDepositConfigurations() {
    return httpClient.get<DepositConfiguration[]>(`pricing/deposit/configurations`)
}

export function getDepositInfo(hash: string) {
    return httpClient.get<DepositInfoResponse>(`pricing/deposit/${hash}/info`)
}

export function useGetDepositConfigurations(enabled: boolean) {
    return useQuery([DEPOSIT_CONFIGURATION_KEY], getDepositConfigurations, {
        enabled,
        refetchOnMount: false,
    })
}

export function waitTimeDepositStatusUpdate(
    id: string,
    status?: PaymentStatus
): Promise<PaymentStatusData> {
    return waitForFieldUpdate({
        errorText:
            "Статус запроса не изменился за 2 минуты. Попробуйте обновить страницу или свяжитесь с поддержкой",
        isEqual: (last, current) => last.status === current.status,
        current: { status },
        promiseFactory: () => getOrderPaymentStatus(id),
    })
}
